import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import SubNavbar from "./SubNavbar";
import {client} from "../sanityClient";


const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        client
            .fetch(
                `*[_type == "productCategory" && !defined(parentCategory)]{
                    _id, title, slug,
                    "subCategories": *[_type == "productCategory" && parentCategory._ref == ^._id]{
                        _id, title, slug
                    }
                }`
            )
            .then(setCategories)
            .catch(console.error);
    }, []);
    return (
        <header className="bg-[#33367b] border-b-8 border-blue-950 z-50 font-OpenSans fixed top-0 left-0 w-full">
            <div className="mx-auto max-w-[1440px] sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">
                    {/* Logo */}
                    <Link className="block" to="/">
                        <img className="h-44 w-auto" src="/assets/images/header/timo.png" alt="Logo" />
                    </Link>

                    {/* Navigation */}
                    <div className="hidden lg:flex">
                        <nav>
                            <ul className="flex items-center gap-10 font-bold text-[0.85rem] 2xl:text-[0.95rem] mt-1 tracking-tighter">

                                <li>
                                    <Link className="text-white hover:text-[#c0c0c0] uppercase" to="/about">Giới
                                        thiệu</Link>
                                </li>

                                {/* Dropdown Sản phẩm */}
                                <li className="relative">
                                    <Link className="text-white hover:text-[#c0c0c0] uppercase" to="/products">sản
                                        phẩm</Link>
                                </li>

                                <li className="relative">
                                    <Link className="text-white hover:text-[#c0c0c0] uppercase" to="/manufacturing">Gia công & sản xuất</Link>
                                </li>

                                <li className="relative">
                                    <Link className="text-white hover:text-[#c0c0c0] uppercase" to="/products">Thiết kế & tư vấn</Link>
                                </li>

                                <li>
                                    <Link className="text-white hover:text-[#c0c0c0] uppercase" to="/news">tin
                                        tức</Link>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    {/* Gửi yêu cầu */}
                    <Link
                        className=" px-3.5 pt-2 pb-1.5 text-[0.85rem] 2xl:text-[0.95rem] tracking-tighter font-bold uppercase bg-[#D4AF37] text-white hover:bg-white hover:text-[#33367b] mt-1"
                        to="/wishlist"
                    >
                        Liên hệ với TIMO
                    </Link>

                    {/* Mobile Menu Button */}
                    <button className="lg:hidden text-white focus:outline-none -ml-4 sm:-ml-56 mr-4" onClick={() => setMenuOpen(!menuOpen)}>
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeWidth={1.5} d="M4 6h16M4 12h16m-7 6h7"/>
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile Sidebar */}
            {menuOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50" onClick={() => setMenuOpen(false)}>
                    <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-lg p-5">
                        <button className="text-gray-700 text-2xl mb-4" onClick={() => setMenuOpen(false)}>✕</button>
                        <nav>
                            <ul className="space-y-4 font-bold text-lg border-b-4 py-6 border-[#0F0F0F]">
                                <li><Link className="block text-gray-700 hover:text-[#33367b]" to="/">Trang chủ</Link>
                                </li>
                                <li><Link className="block text-gray-700 hover:text-[#33367b]" to="/about">Giới
                                    thiệu</Link></li>


                                <li><Link className="block text-gray-700 hover:text-[#33367b]" to="/products">Sản
                                    phẩm</Link></li>

                                <li><Link className="block text-gray-700 hover:text-[#33367b]" to="/products">Gia công & sản xuất</Link></li>

                                <li><Link className="block text-gray-700 hover:text-[#33367b]" to="/products">Thiết kế & tư vấn</Link></li>

                                <li><Link className="block text-gray-700 hover:text-[#33367b]" to="/news">Blog</Link>
                                </li>
                                <li>
                                    <Link
                                        className="border-b-2 border-indigo-800 text-indigo-800 tracking-tighter font-extrabold uppercase mt-1"
                                        to="/wishlist"
                                    >
                                        Gửi yêu cầu
                                    </Link>
                                </li>
                            </ul>
                            <ul className=" mt-2 space-y-2">
                                {categories.map((category) => (
                                    <li key={category._id}>
                                        <Link
                                            to={`/products?category=${category._id}`}
                                            className="text-gray-700 font-bold text-lg hover:text-[#33367b]"
                                        >
                                            {category.title}
                                        </Link>

                                        {/* Hiển thị thể loại Con */}
                                        {category.subCategories.length > 0 && (
                                            <ul className="ml-2 mt-1 space-y-1 text-gray-700">
                                                {category.subCategories.map((sub) => (
                                                    <li key={sub._id}>
                                                        <Link
                                                            to={`/products?category=${sub._id}`}
                                                            className="block text-gray-600 font-semibold text-base hover:text-[#33367b]"
                                                        >
                                                            {sub.title}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>
            )}

            <SubNavbar/>
        </header>
    );
};

export default Header;
